import { Inject, Injectable } from '@angular/core';
import { NavigationBehaviorOptions, NavigationExtras, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { MEETING_ANALYSIS_ROUTE_PREFIX$ } from './constants';

@Injectable({ providedIn: 'root' })
export class MeetingAnalysisRouterService {
  constructor(
    private router: Router,
    @Inject(MEETING_ANALYSIS_ROUTE_PREFIX$) public readonly routePrefix$: Observable<string>,
  ) {}

  public navigate(commands: any[], extras?: NavigationExtras): void {
    this.routePrefix$.pipe(take(1)).subscribe((routePrefix) => {
      if (commands.length > 0 && routePrefix) {
        commands.unshift(routePrefix);
      }
      this.router.navigate(commands, extras);
    });
  }

  public navigateByUrl(url: string | UrlTree, extras?: NavigationBehaviorOptions): void {
    this.routePrefix$.pipe(take(1)).subscribe((routePrefix) => {
      if (routePrefix) {
        url = routePrefix + url;
      }
      this.router.navigateByUrl(url, extras);
    });
  }

  public applyRoutePrefix(url: string): Observable<string> {
    return this.routePrefix$.pipe(
      take(1),
      map((routePrefix) => {
        return routePrefix ? routePrefix + url : url;
      }),
    );
  }
}
